export enum CantPayOnDeliveryReason {
	PriceTooHigh = "PriceTooHigh",
	HasMustPayOnlineOption = "HasMustPayOnlineOption",
}
